<template>
  <div class="word-cloud-layer">
    <word-cloud
      :visible="TopnavMsg.isShowWordCloudDialog"
      ref='wordCloud'
    ></word-cloud>

    <import-text></import-text>
    <text-to-shape></text-to-shape>
    <confirm-cloud></confirm-cloud>

    <!-- <user-guide></user-guide> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import wordCloud from './emodal/wordCloud/wordCloudDialog.vue'
import importText from './emodal/wordCloud/modals/importText.vue'
import textToShape from './emodal/wordCloud/modals/textToShape.vue'
import confirmCloud from './emodal/wordCloud/modals/confirmCloud.vue'
import userGuide from './emodal/wordCloud/modals/userGuide.vue'

export default {
  components: {
    wordCloud,
    importText,
    textToShape,
    confirmCloud,
    userGuide,
  },
  data () {
    return {
    }
  },
  created () {

  },
  computed: {
    ...mapGetters([
      'TopnavMsg',
    ])
  },
  watch: {
    'TopnavMsg.isShowWordCloudDialog' (val) {
      if (val) {
        this.$bus.emit('userGuide.show');
        this.$refs.wordCloud.handleGuide();
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.word-cloud-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 25;
}
</style>



// WEBPACK FOOTER //
// src/components/WordCloud.vue